/* PR 53 fixes · F9 (P52-S1) — "Clear" / "Un-clear" on a restatement FLAG of the IFRS validation screen. A Reviewer / Manager /
   Partner gives a reason; the server refuses other roles, a locked engagement and a Final report (EN + AR). A cleared FLAG counts
   as passed; it shows again when its amount changes. */
import React, { useState } from "react";
import api, { toErrMsg } from "@/lib/api";
import { useI18n } from "@/contexts/I18nContext";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtDate } from "@/lib/dt";
import { toast } from "sonner";

export default function RestatementFlagClear({ engId, check, onChanged }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  if (!engId || !check?.key || (!check.can_clear && !check.cleared)) return null;
  const url = `/engagements/${engId}/restatements-checks/${check.key}/clearance`;
  const clear = async () => {
    setBusy(true);
    try { await api.put(url, { reason }); toast.success(t("b34q.cleared")); setOpen(false); setReason(""); onChanged?.(); }
    catch (e) { toast.error(toErrMsg(e, t("common.failed"))); } finally { setBusy(false); }
  };
  const unclear = async () => {
    setBusy(true);
    try { await api.delete(url); toast.success(t("b34q.uncleared")); onChanged?.(); }
    catch (e) { toast.error(toErrMsg(e, t("common.failed"))); } finally { setBusy(false); }
  };
  if (check.cleared) {
    return (
      <span className="ms-2 inline-flex items-center gap-1 text-[11px] text-muted-foreground" data-testid={`flag-cleared-${check.key}`}>
        {t("b34q.clearedBy").replace("{name}", check.cleared_by_name || "").replace("{date}", fmtDate(check.cleared_at))}
        <Button size="sm" variant="ghost" className="h-6 px-1 text-[11px]" disabled={busy} onClick={unclear}
                data-testid={`flag-unclear-${check.key}`}>{t("b34q.unclear")}</Button>
      </span>
    );
  }
  return (
    <>
      <Button size="sm" variant="outline" className="ms-2 h-6 px-2 text-[11px]" onClick={() => setOpen(true)}
              data-testid={`flag-clear-${check.key}`}>{t("b34q.clear")}</Button>
      <Dialog open={open} onOpenChange={(v) => !v && setOpen(false)}>
        <DialogContent data-testid="flag-clear-dialog">
          <DialogHeader><DialogTitle>{t("b34q.clearTitle")}</DialogTitle></DialogHeader>
          <div className="text-xs text-muted-foreground">{t("b34q.clearHint")}</div>
          <div className="text-sm">
            <div className="mb-1 text-xs text-muted-foreground">{t("b34q.reason")}</div>
            <Textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} data-testid="flag-clear-reason" />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>{t("b34q.cancel")}</Button>
            <Button disabled={busy || !reason.trim()} onClick={clear} data-testid="flag-clear-confirm">{t("b34q.confirmClear")}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
